module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jjylzy1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjjylzy1.png
// module id = epCh
// module chunks = 93